<template>
  <h1> this view is coming soon...</h1>
</template>
<script>

export default {
  name: 'DesktopView',
  components: {}
}
</script>